import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Collections from "@/pages/Collections";
import ProductDetail from "@/pages/ProductDetail";
import Brands from "@/pages/Brands";
import VenusGifting from "@/pages/VenusGifting";
import AgaroCollection from "@/pages/AgaroCollection";
import CelloCollection from "@/pages/CelloCollection";
import CorporateGifting from "@/pages/CorporateGifting";
import CustomGifting from "@/pages/CustomGifting";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import GiftingList from "@/pages/GiftingList";
import RequestQuote from "@/pages/RequestQuote";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollManager />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/venus-gifting" element={<VenusGifting />} />
        <Route path="/agaro-collection" element={<AgaroCollection />} />
        <Route path="/cello-collection" element={<CelloCollection />} />
        <Route path="/corporate-gifting" element={<CorporateGifting />} />
        <Route path="/custom-gifting" element={<CustomGifting />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gifting-list" element={<GiftingList />} />
        <Route path="/request-quote" element={<RequestQuote />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-left" toastOptions={{ style: { background: "#161616", border: "1px solid rgba(197,160,89,0.35)", color: "#FBF9F5", borderRadius: 0 } }} />
      </StoreProvider>
    </div>
  );
}

export default App;
